// extracted by mini-css-extract-plugin
export var legendIndicator = "_de-1";
export var legendRight = "_de-0";